import { useState, useEffect } from "react";
import { Auth } from "aws-amplify";

import { ThemeProvider } from "@mui/material/styles";
import { customTheme } from "./theme";
import { SnackbarProvider } from "notistack";
import { customSnackbarComponents } from "./theme/snackbars";

import TagManager from "react-gtm-module";

import "./App.scss";
// import { SevereWeatherDialog } from "./components/shared/popups/severeWeatherDialog";
import { ThanksgivingSeasonDialog } from "./components/shared/popups/thanksgivingSeasonDialog";
// import { OfferDialog } from "./components/shared/popups/offerDialog";
import { HvacOfferDialog } from "./components/shared/popups/hvacOfferDialog";
import { ElectricityPlanDialog } from "./components/shared/popups/electricityPlanDialog";

import Main from "./Main";
import { isSessionAuthenticated, removeImpersonate } from "./services/auth";
import { useAppDispatch, useAppSelector } from "./store/hook";

import { logout } from "./store/modules/meSlice";

const gtmId = process.env.REACT_APP_GTM_ID;

if (process.env.REACT_APP_HOST_ENV !== "development") {
  TagManager.initialize({ gtmId: gtmId });
}

function App() {
  const { isImpersonating, impersonateTtl, showPopup } = useAppSelector(
    (state) => state.me || ({} as any)
  );
  const dispatch = useAppDispatch();
  const [openPopup, setOpenPopup]: any = useState(undefined);

  useEffect(() => {
    const checkImpersonation = async () => {
      const isLoggedIn = await isSessionAuthenticated();

      if (isImpersonating && impersonateTtl) {
        if (!isLoggedIn) {
          removeImpersonate();
          return;
        }

        setInterval(() => {
          if (Number(impersonateTtl) < new Date().valueOf()) {
            console.log("Impersonation session expired!");
            Auth.signOut().then(() => {
              removeImpersonate();
              dispatch(logout());
              window.location.reload();
            });
          }
        }, 1000); // check every second
      }
    };

    checkImpersonation();
  }, []);

  useEffect(() => {
    if (!isImpersonating) {
      setOpenPopup(showPopup)
    }
  }, [showPopup]);

  return (
    <ThemeProvider theme={customTheme}>
      <SnackbarProvider
        maxSnack={6}
        anchorOrigin={{
          horizontal: "left",
          vertical: "bottom",
        }}
        Components={customSnackbarComponents}
        autoHideDuration={3000}
      >
        <Main />
      </SnackbarProvider>
      {/* <SevereWeatherDialog open={openPopup === 'severeWeather'}/> */}
      <ThanksgivingSeasonDialog open={openPopup === 'thanksgivingSeason'}/>
      {/* <OfferDialog open={openPopup === 'thanksgivingSeason'}/> */}
      <HvacOfferDialog open={openPopup === 'hvacOffer'}/>
      <ElectricityPlanDialog open={openPopup === 'electricityPlan'}/>
    </ThemeProvider>
  );
}

export default App;
